"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var ConfigProvider_1 = require("../../ConfigProvider");
// eslint-disable-next-line func-names
function default_1() {
    var config = react_1.useContext(ConfigProvider_1.ConfigContext).config;
    return config;
}
exports.default = default_1;
//# sourceMappingURL=index.js.map